import type { PointerPoint } from './pointerSession'

export type TwoPointerState = { dist: number; angle: number; cx: number; cy: number }

export function twoPointerState(a: PointerPoint, b: PointerPoint): TwoPointerState {
  return {
    dist: Math.max(1, Math.hypot(b.x - a.x, b.y - a.y)),
    angle: (Math.atan2(b.y - a.y, b.x - a.x) * 180) / Math.PI,
    cx: (a.x + b.x) / 2,
    cy: (a.y + b.y) / 2,
  }
}

/** Skalierung, Rotation (Grad) und Verschiebung relativ zum Gestenstart. */
export function twoPointerDelta(start: TwoPointerState, now: TwoPointerState): { scale: number; rotationDeg: number; dx: number; dy: number } {
  let rot = now.angle - start.angle
  while (rot > 180) rot -= 360
  while (rot < -180) rot += 360
  return { scale: now.dist / start.dist, rotationDeg: rot, dx: now.cx - start.cx, dy: now.cy - start.cy }
}
